/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function getProfileData() {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/my-profile`, {});

  return (await result).data;
}

export async function updateProfileData({
  firstName,
  lastName,
  phoneNumber,
  phoneExtension,
  state,
  city,
  addressLine1,
  addressLine2,
  zipCode,
}) {
  const data = {
    firstName,
    lastName,
    phoneNumber,
    phoneExtension,
    state,
    city,
    addressLine1,
    addressLine2,
    zipCode,
  };

  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/profile`, {
    method: "PUT",
    data,
  });
  return (await result).data;
}

export async function updateProfilePic(params) {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/profile-photo`, {
    method: "PATCH",
    params,
  });
  return (await result).data;
}
